import { LogItemLayout, LogItemProps } from '../LogItemLayout';
import { useTitle } from './useTitle';
import { useDetail } from './useDetail';
import { useStore } from '../LogItemTask/useStore';

export const LogItemPolicy = (props: LogItemProps) => {
  const { data, platform, region, round } = props;

  const title = useTitle(data, round);
  const detail = useDetail(data, platform, region);
  const store = useStore(data);

  return (
    <LogItemLayout
      {...props}
      title={title}
      before={detail?.before}
      after={detail?.after}
      removeStore={store?.removeStore}
      addStore={store?.addStore}
    />
  );
};
